import { paths } from "@/App";
import { Button } from "@/lib/components/Button/Button";
import { buttonVariants } from "@/lib/components/Button/button-variants";
import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/lib/components/DropdownMenu";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { IconChevronLeft, IconVideo } from "@tabler/icons-react";
import { Link, useParams } from "react-router";

export default function EditorBackNavigation() {
  const { teamExternalId } = useParams();
  const thirdPartyEditorInfo = useEditorStore(
    (state) => state.thirdPartyEditorInfo,
  );
  const folderExternalId = useEditorStore(
    (state) => state.video?.folderExternalId,
  );

  const backToVideosPath = folderExternalId
    ? paths.videosFolder(teamExternalId!, folderExternalId)
    : paths.videos(teamExternalId!);

  if (!thirdPartyEditorInfo) {
    return (
      <Link
        to={backToVideosPath}
        className={buttonVariants({ variant: "ghost", size: "icon" })}
      >
        <IconChevronLeft className="text-text-primary" />
      </Link>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <IconChevronLeft className="text-text-primary" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-52">
        <Link to={backToVideosPath}>
          <DropdownMenuItem>
            <IconVideo className="text-text-primary" />
            <span>Back to video list</span>
          </DropdownMenuItem>
        </Link>
        <a href={thirdPartyEditorInfo.redirectUrl}>
          <DropdownMenuItem>
            <img
              src={thirdPartyEditorInfo.squareLogoSrc}
              alt={thirdPartyEditorInfo.displayName}
              className="h-4 w-4 object-contain object-center"
            />
            {`Back to ${thirdPartyEditorInfo.displayName}`}
          </DropdownMenuItem>
        </a>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
